exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".prod-system {\r\n  background-color: #e2edea;\r\n}\r\n\r\n.prod-system table tr td .content {\r\n  border-left: 2px solid #84baac;\r\n}\r\n\r\n.prod-system table tr {\r\n  border-bottom: 2px solid #84baac;\r\n}\r\n\r\n.prod-system table img {\r\n  width: 150px;\r\n  height: 150px;\r\n}\r\n\r\n@media (min-width: 768px) {\r\n  .table-responsive {\r\n    width: 75%;\r\n    margin: 0 auto;\r\n  }\r\n}\r\n\r\n@media (max-width: 576px)  {\r\n  .prod-system table img {\r\n    width: 80px;\r\n    height: 80px;\r\n  }\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/anach/Desktop/tengtu-website/src/app/components/education-and-career/prod-system/prod-system.component.css
// module id = ../../../../../src/app/components/education-and-career/prod-system/prod-system.component.css
// module chunks = main